// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationAdditionalIcdCodes } from './priorAuthorizationAdditionalIcdCodes.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationProcedureCodes {
    'code': string;
    'unit': string;
    'startDate': Moment;
    'endDate'?: Moment;
    'primaryIcdCode': string;
    'primaryIcdDescription'?: string;
    'placeOfService'?: string;
    'codeModifier'?: string;
    'codeDescription'?: string;
    'additionalIcdCodes'?: Array<PriorAuthorizationAdditionalIcdCodes>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationProcedureCodes>> = [
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "unit",
            "baseName": "unit",
            "type":     "string"
        },
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "Date"
        },
        {
            "name":     "endDate",
            "baseName": "endDate",
            "type":     "Date"
        },
        {
            "name":     "primaryIcdCode",
            "baseName": "primaryIcdCode",
            "type":     "string"
        },
        {
            "name":     "primaryIcdDescription",
            "baseName": "primaryIcdDescription",
            "type":     "string"
        },
        {
            "name":     "placeOfService",
            "baseName": "placeOfService",
            "type":     "string"
        },
        {
            "name":     "codeModifier",
            "baseName": "codeModifier",
            "type":     "string"
        },
        {
            "name":     "codeDescription",
            "baseName": "codeDescription",
            "type":     "string"
        },
        {
            "name":     "additionalIcdCodes",
            "baseName": "additionalIcdCodes",
            "type":     "Array<PriorAuthorizationAdditionalIcdCodes>"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationProcedureCodes.attributeTypeMap;
    }
}
